// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1Kqy6","amount":"Amount_amount__1qSwq","tip":"Amount_tip__3eSbf","tipHeader":"Amount_tipHeader__YGiJv","tipsWrap":"Amount_tipsWrap__2GRrA"};